import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import Carousel from 'marketplace-ui-common/components/Carousel';
import { useCollections } from 'marketplace-ui-common/collections/hooks/useCollections';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import CollectionCard from './ThemeCollectionCard';
import { getIsInApp } from '../../selectors/app';
import { resultCardStyles } from '../../storefront/utils/resultCardStyles';
import { getThemesStorefrontRoute } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCollectionCard = styled(CollectionCard).withConfig({
  displayName: "ThemeCollectionsCardGrid__StyledCollectionCard",
  componentId: "w8svkv-0"
})(["", ""], resultCardStyles);
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ThemeCollectionsCardGrid__StyledRouterLink",
  componentId: "w8svkv-1"
})(["display:flex;align-items:stretch;"]);
export default function ThemeCollectionsCardGrid() {
  const isInApp = useSelector(getIsInApp);
  const {
    getDisplayedCollections,
    requestState
  } = useCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const {
    maxCardsPerPage
  } = useResponsiveProps({
    maxCardsPerPage: {
      [ScreenSizes.SM]: 1,
      [ScreenSizes.MD]: 2,
      [ScreenSizes.LG]: 3
    }
  });
  const displayedCollections = getDisplayedCollections();
  const collectionCards = useMemo(() => displayedCollections.map(collection => collection.publishedListing && /*#__PURE__*/_jsx(StyledRouterLink, {
    style: {
      height: '100%'
    },
    to: getThemesStorefrontRoute(collection.publishedListing.slug),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(StyledCollectionCard, {
      collection: collection
    })
  }, `collection-${collection.id}`)), [displayedCollections]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: requestState,
    children: /*#__PURE__*/_jsx(Carousel, {
      cards: collectionCards,
      maxCardsPerPage: maxCardsPerPage
    })
  });
}